export var UserRole;
(function (UserRole) {
    UserRole[UserRole["INFINITEX_DEVELOPER"] = 7] = "INFINITEX_DEVELOPER";
    UserRole[UserRole["INFINITE_FLIGHT_STAFF"] = 3] = "INFINITE_FLIGHT_STAFF";
    UserRole[UserRole["MODERATOR"] = 2] = "MODERATOR";
    UserRole[UserRole["IFATC"] = 1] = "IFATC";
    UserRole[UserRole["PILOT"] = 0] = "PILOT";
})(UserRole || (UserRole = {}));
